import evaluateErrorReturn from '@/utils/errors/evaluateErrorReturn';

export const generateSnackBarError = e => ({
	content: evaluateErrorReturn(e),
	color: 'error',
});

export const snackBarError = e => commit => {
	// 401 error de autenticacion, enviamos un warning
	if (e.response.status == 401)
		commit(
			'Snackbar/showMessage',
			{ content: 'Debe iniciar sesion nuevamente', color: 'warning' },
			{ root: true }
		);
	else commit('Snackbar/showMessage', generateSnackBarError(e), { root: true });
};

export const snackBarSuccess = message => commit => {
	commit(
		'Snackbar/showMessage',
		{
			content: message,
			color: 'success',
		},
		{ root: true }
	);
};
